// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"228":"96ed1422","433":"86c91669","453":"e853688d"}[chunkId] + ".chunk.js";
};